import type React from "react"
import { Spin, Typography } from "antd"
import { LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons"

const { Title, Paragraph } = Typography

interface SaveStepProps {
  isCreatingTags: boolean
  currentConfirmationMessage: string
  selectedTagCount: number
  totalTagCount: number
}

export const SaveStep: React.FC<SaveStepProps> = ({
  isCreatingTags,
  currentConfirmationMessage,
  selectedTagCount,
  totalTagCount,
}) => {
  return (
    <div className="text-center py-12 mt-4">
      {isCreatingTags ? (
        <>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} className="mb-8" />
          <Title level={3} className="mb-6">
            {currentConfirmationMessage}
          </Title>
          <Paragraph className="text-gray-500">
            We're finalizing your selected tags and adding them to your system.
          </Paragraph>
        </>
      ) : (
        <>
          <CheckCircleOutlined style={{ fontSize: 48, color: "#52c41a" }} className="mb-8" />
          <Title level={3} className="mb-6">
            Ready to Save {selectedTagCount} Tags?
          </Title>
          <Paragraph>
            You've selected {selectedTagCount} out of {totalTagCount} generated tags.
          </Paragraph>
          <Paragraph className="text-gray-500 mb-8">
            Click "Save Tags" to add these to your system or go back to make changes.
          </Paragraph>
        </>
      )}
    </div>
  )
}
